import React from 'react'
import { Tr, Td, useDisclosure, Collapse, Box, Text, Flex, IconButton, Badge, Divider, Link, Tooltip, Button, HStack } from '@chakra-ui/react'
import { FiChevronDown, FiChevronUp, FiPhone, FiMail, FiMessageSquare } from 'react-icons/fi'
import { format } from 'date-fns'

const formatarData = (dataString) => {
  if (!dataString) return ''

  try {
    return format(new Date(dataString), 'dd/MM/yyyy HH:mm')
  } catch (e) {
    return dataString
  }
}

const formatarTelefone = (telefone) => {
  if (!telefone) return '-'

  const numero = telefone.replace(/\D/g, '')

  if (numero.length === 11) {
    return `(${numero.substring(0, 2)}) ${numero.substring(2, 7)}-${numero.substring(7)}`
  } else if (numero.length === 10) {
    return `(${numero.substring(0, 2)}) ${numero.substring(2, 6)}-${numero.substring(6)}`
  }

  return telefone
}

const getLinkWhatsApp = (telefone) => {
  if (!telefone) return '#'
  const numeroPuro = telefone.replace(/\D/g, '')
  return `https://wa.me/55${numeroPuro}`
}

export const LinhaAcompanhamentoApas = ({ cliente }) => {
  const { isOpen, onToggle } = useDisclosure()

  return (
    <>
      <Tr>
        <Td p={2} borderRight="1px" borderColor="gray.100" borderBottom="none">
          <IconButton
            aria-label={isOpen ? 'Fechar detalhes' : 'Ver detalhes'}
            icon={isOpen ? <FiChevronUp /> : <FiChevronDown />}
            size="sm"
            onClick={onToggle}
            variant="ghost"
          />
        </Td>
        <Td borderRight="1px" borderColor="gray.100" borderBottom="none">
          {formatarData(cliente.data_cadastro)}
        </Td>
        <Td borderRight="1px" borderColor="gray.100" borderBottom="none">
          {cliente.nome_cliente}
        </Td>
        <Td borderRight="1px" borderColor="gray.100" borderBottom="none">
          {cliente.empresa || '-'}
        </Td>
        <Td borderRight="1px" borderColor="gray.100" borderBottom="none">
          {formatarTelefone(cliente.celular)}
        </Td>
        <Td borderRight="1px" borderColor="gray.100" borderBottom="none">
          {cliente.nome_vendedor || (
            <Badge colorScheme="gray" fontSize="0.8em">
              Não atribuído
            </Badge>
          )}
        </Td>
        <Td>
          <HStack spacing={2}>
            <Tooltip label="Ligar" hasArrow>
              <IconButton size="sm" colorScheme="blue" variant="outline" icon={<FiPhone />} as="a" href={`tel:${cliente.celular}`} />
            </Tooltip>

            {cliente.email_cliente && (
              <Tooltip label="Email" hasArrow>
                <IconButton size="sm" colorScheme="purple" variant="outline" icon={<FiMail />} as="a" href={`mailto:${cliente.email_cliente}`} />
              </Tooltip>
            )}

            <Tooltip label="WhatsApp" hasArrow>
              <IconButton
                size="sm"
                colorScheme="green"
                variant="outline"
                icon={<FiMessageSquare />}
                as="a"
                href={getLinkWhatsApp(cliente.celular)}
                target="_blank"
              />
            </Tooltip>
          </HStack>
        </Td>
      </Tr>
      <Tr>
        <Td colSpan={7} p={0} borderTop="none">
          <Collapse in={isOpen} animateOpacity>
            <Box p={4} bg="white" borderTop="1px" borderColor="gray.100">
              <Flex direction="column" gap={4}>
                <Text fontWeight="bold" fontSize="lg">
                  Detalhes do Cliente
                </Text>

                <Flex justifyContent="space-between" flexWrap="wrap" gap={4}>
                  <Box minW="250px" flex="1">
                    <Text fontWeight="medium">Informações de Contato</Text>
                    <Divider my={2} />

                    <Flex justify="space-between" mb={2}>
                      <Text fontWeight="medium">Data de Cadastro:</Text>
                      <Text>{formatarData(cliente.data_cadastro)}</Text>
                    </Flex>

                    <Flex justify="space-between" mb={2}>
                      <Text fontWeight="medium">Nome:</Text>
                      <Text>{cliente.nome_cliente}</Text>
                    </Flex>

                    <Flex justify="space-between" mb={2}>
                      <Text fontWeight="medium">Empresa:</Text>
                      <Text>{cliente.empresa || 'Não informado'}</Text>
                    </Flex>

                    <Flex justify="space-between" mb={2}>
                      <Text fontWeight="medium">Telefone:</Text>
                      <Link href={getLinkWhatsApp(cliente.celular)} isExternal color="green.500">
                        {formatarTelefone(cliente.celular)}
                      </Link>
                    </Flex>

                    {cliente.email_cliente && (
                      <Flex justify="space-between" mb={2}>
                        <Text fontWeight="medium">E-mail:</Text>
                        <Link href={`mailto:${cliente.email_cliente}`} color="blue.500">
                          {cliente.email_cliente}
                        </Link>
                      </Flex>
                    )}
                  </Box>

                  <Box minW="250px" flex="1">
                    <Text fontWeight="medium">Informações de Atendimento</Text>
                    <Divider my={2} />

                    <Flex justify="space-between" mb={2}>
                      <Text fontWeight="medium">Vendedor:</Text>
                      <Text>{cliente.nome_vendedor || 'Não atribuído'}</Text>
                    </Flex>

                    <Flex justify="space-between" mb={2}>
                      <Text fontWeight="medium">Código do Vendedor:</Text>
                      <Text>{cliente.codigo_usuario || 'N/A'}</Text>
                    </Flex>

                    <Flex justify="space-between" mb={2}>
                      <Text fontWeight="medium">ID Cliente:</Text>
                      <Badge colorScheme="blue">{cliente.id}</Badge>
                    </Flex>

                    <Box mt={4}>
                      <Button
                        colorScheme="green"
                        size="sm"
                        leftIcon={<FiMessageSquare />}
                        as="a"
                        href={getLinkWhatsApp(cliente.celular)}
                        target="_blank"
                        width="100%"
                      >
                        Iniciar conversa no WhatsApp
                      </Button>
                    </Box>
                  </Box>
                </Flex>
              </Flex>
            </Box>
          </Collapse>
        </Td>
      </Tr>
    </>
  )
}
